package my.drivebit.viewmodels

val imageUrl = "/images"
